<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <tradeList v-show="detailsVisible"  ref="tradeList"></tradeList>
  </div>
</template>

<script>
    //table封装组件
    //table封装组件
    import tablePage from '@/views/mis/customerRelation/table.vue'
    import FORM from '../components/page/form.vue'
    import tradeList from '../rebate/tradeList.vue'
    import UPDATE from '../components/page/update.vue'
    import DataUtil from '@/views/mis/util/data'
    import download from '@/utils/download'
    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    let relationType = {0: "客户", 1: "直接", 2: "间接"};
    let demo = {0: "真实", 1: "模拟"};
    let levelType = {"mMIN":"迷你","mSTD":"标准","mVIP":"金钻"};
    let symbolType = {"2": "外汇", "1": "贵金属", "5": "指数", "4": "商品", "-1": "不限产品","100": "非虚拟币", "7": "股票", "6": "货币"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE,
            tradeList
        },
        methods: {
            checkbox(row){
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    this.$refs.childUpdate.open(row);
                } else if (clickName == "details") {
                    this.showTradeDetails(row,true);
                }
            },
            // 新增 / 修改
            showTradeDetails(row,type) {
                this.detailsVisible = true;
                this.$nextTick(() => {
                    this.$refs.tradeList.init(row)
                })
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('mis.bt.query') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                }else if(window.$t('mis.bt.down') == clickName){
                    //隐藏关键字段
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
                    download.exportExcel(URL.tradingRebate.downloadTradeDetails,param,window.$t('mis.rewardTradeDetails.downloadTradeDetails'));
                }else if(window.$t('mis.bt.export') == clickName){
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
                    download.exportExcel(URL.tradingRebate.downloadTradeDetails,param,window.$t('mis.rewardTradeDetails.downloadTradeDetails'));
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage("",model,res => {
                    if (res.data.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{

                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.axios.post(url, Qs.stringify(option || {})).then(res => {

                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                detailsVisible: false,
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        {title: window.$t('mis.common.startTime'), field: 'beginDate', type: 5},
                        {title: window.$t('mis.common.endTime'), field: 'endDate', type: 5},
                        {title: window.$t('mis.rewardTradeDetails.currentCustomerNumber'), field: 'currentCustomerNumber'},
                        {title: window.$t('mis.rewardTradeDetails.currentMobilePhone'), field: 'currentMobilePhone'},
                        {title: window.$t('mis.rewardTradeDetails.excuteCustomerNumber'), field: 'excuteCustomerNumber'},
                        {title: window.$t('mis.rewardTradeDetails.mobilePhone'), field: 'mobilePhone'},
                        {title: window.$t('mis.rewardTradeDetails.relationType'), field: 'relationType',type: 2, optionList: relationType, isNumber: true},
                        {title: 'actType', field: 'actType', data: 0, hidden: true},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.bt.down')},
                        {click: window.$t('mis.bt.export')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.tradingRebate.tradeDetailsList, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.rewardTradeDetails.currentCustomerNumber'), field: 'currentCustomerNumber'},
                        { title: window.$t('mis.rewardTradeDetails.currentMobilePhone'), field: 'currentMobilePhone'},
                        { title: window.$t('mis.rewardTradeDetails.currentChineseName'), field: 'currentChineseName'},
                        { title: window.$t('mis.rewardTradeDetails.excuteCustomerNumber'), field: 'excuteCustomerNumber'},
                        { title: window.$t('mis.rewardTradeDetails.mobilePhone'), field: 'mobilePhone'},
                        {title: window.$t('mis.rewardTradeDetails.demo'), field: 'demo',render: (data, full) => {
                                return demo[data] || "";
                            }},
                        {title: window.$t('mis.rewardTradeDetails.levelType'), field: 'levelType',render: (data, full) => {
                                return levelType[data] || "";
                            }},
                        { title: window.$t('mis.accountReward.activeId'), field: 'activeId'},
                        {title: window.$t('mis.rewardTradeDetails.symbolType'), field: 'symbolType',render: (data, full) => {
                                return symbolType[data] || "";
                            }},
                        { title: window.$t('mis.rewardTradeDetails.symbol'), field: 'symbol'},
                        { title: window.$t('mis.rewardTradeDetails.orderid'), field: 'orderid'},
                        { title: window.$t('mis.rewardTradeDetails.execVolume'), field: 'execVolume',h5Click: "details",h5ClickRender:(data, full) => {
                                if(full.complianceStatus==1&&DateUtil.isNotEmpty(full.tradeIds)) {
                                    return true;
                                }
                                return false;
                            }},
                        { title: window.$t('mis.rewardTradeDetails.relationType'), field: 'relationType',render: (data, full) => {
                                return relationType[data] || "";
                            }},
                        { title: window.$t('mis.rewardTradeDetails.directPhone'), field: 'directPhone'},
                        { title: window.$t('mis.rewardTradeDetails.indirectPhone'), field: 'indirectPhone'},
                        { title: window.$t('mis.rewardTradeDetails.currentRebete'), field: 'currentRebete'},
                        { title: window.$t('mis.rewardTradeDetails.ctime'), field: 'ctime', render: (data, full) => {
                                return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
                            }}
                    ]
                }
            }
        }
    }
</script>
